<template>
  <div class="formularioprospecto-princ">
    <TituloSeccion v-if="!esRegistroDeFiguraAdicional" :titulo="this.titulo" />
    <TituloSeccion v-else :titulo="this.titulo" />
    <div class="container container-registro-prospecto">
      <form
        class="requiere-validacion mb-2"
        novalidate
        ref="formularioRegistroProspecto"
        v-bind:class="{ 'was-validated': formularioRegistroProspectoValidado }"
      >
        <div class="row row-cols-lg-12 w-100 fila--campos">
          <div class="col-lg-6 columna--campos">
            <etiqueta-campo
              texto="¿Qué tipo de persona vas a registrar?"
              :requerido="true"
            ></etiqueta-campo>
            <DropDown
              :disabled="this.prospecto.ProspectoId != 0"
              placeholder="Selecciona el tipo de persona que registrarás * "
              :arreglo="this.TiposPersona"
              llave="value"
              valor="value"
              texto="text"
              v-model="prospecto.TipoPersona"
              :requerido="true"
              invalidFeedback="Debes seleccionar un tipo de persona."
            ></DropDown>
          </div>
          <!--Nombres-->
          <div class="col-lg-6 columna--campos">
            <div v-if="prospecto.TipoPersona == 1">
              <etiqueta-campo
                texto="Nombre comercial"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Nombre comercial *"
                type="text"
                class="form-control campo-basico"
                v-model="prospecto.Nombres"
                required
              />
            </div>
            <div
              v-else-if="
                prospecto.TipoPersona == 0 ||
                  prospecto.TipoPersona == 2 ||
                  prospecto.TipoPersona == 4 ||
                  prospecto.TipoPersona == 6 ||
                  prospecto.TipoPersona == 5 ||
                  prospecto.TipoPersona == 7
              "
            >
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Nombre(s) *"
                type="text"
                class="form-control campo-basico"
                v-model="prospecto.Nombres"
                required
              />
            </div>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Debes ingresar el nombre del prospecto
            </div>
          </div>
        </div>
        <div
          v-if="
            prospecto.TipoPersona == 2 ||
              prospecto.TipoPersona == 5 ||
              prospecto.TipoPersona == 7
          "
          class="col-lg-6 columna--campos"
        >
          <div>
            <etiqueta-campo
              texto="Segundo Nombre (Middle Name)"
            ></etiqueta-campo>
            <input
              placeholder="Segundo Nombre (Middle Name)"
              type="text"
              class="form-control campo-basico"
              v-model="prospecto.ApellidoMaterno"
            />
          </div>
        </div>
        <!--Apellido Paterno-->
        <div class="row row-cols-lg-12 w-100 fila--campos">
          <div class="col-lg-6 col-sm-12 columna--campos">
            <div v-if="prospecto.TipoPersona == 1">
              <etiqueta-campo
                texto="Razón social"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Razon social *"
                type="text"
                class="form-control campo-basico"
                v-model="prospecto.ApellidoPaterno"
                required
              />
            </div>
            <div
              v-else-if="
                prospecto.TipoPersona == 0 ||
                  prospecto.TipoPersona == 4 ||
                  prospecto.TipoPersona == 6
              "
            >
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido paterno *"
                type="text"
                class="form-control campo-basico"
                v-model="prospecto.ApellidoPaterno"
                required
              />
            </div>
            <div
              v-else-if="
                prospecto.TipoPersona == 2 ||
                  prospecto.TipoPersona == 5 ||
                  prospecto.TipoPersona == 7
              "
            >
              <etiqueta-campo
                texto="Apellido paterno (Surname or family name)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido paterno (Surname or family name) *"
                type="text"
                class="form-control campo-basico"
                v-model="prospecto.ApellidoPaterno"
                required
              />
            </div>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Debe ingresar el apellido paterno del prospecto
            </div>
          </div>
          <!--Apellido Materno-->
          <div
            v-if="
              prospecto.TipoPersona == 0 ||
                prospecto.TipoPersona == 1 ||
                prospecto.TipoPersona == 4 ||
                prospecto.TipoPersona == 6
            "
            class="col-lg-6 col-sm-12 columna--campos"
          >
            <div v-if="prospecto.TipoPersona == 1">
              <etiqueta-campo texto="RFC" :requerido="true"></etiqueta-campo>
              <input
                placeholder="RFC"
                type="text"
                maxlength="12"
                class="form-control campo-basico"
                v-model="prospecto.ApellidoMaterno"
                required
              />
            </div>
            <div
              v-else-if="
                prospecto.TipoPersona == 0 ||
                  prospecto.TipoPersona == 4 ||
                  prospecto.TipoPersona == 6
              "
            >
              <etiqueta-campo
                texto="Apellido materno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido materno"
                type="text"
                class="form-control campo-basico"
                v-model="prospecto.ApellidoMaterno"
                required
              />
            </div>

            <div
              v-if="prospecto.TipoPersona == 1"
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Debe ingresar el RFC
            </div>
          </div>
        </div>

        <div class="row row-cols-lg-12 w-100 fila--campos">
          <div class="col-lg-6 col-sm-12 columna--campos">
            <etiqueta-campo
              texto="Teléfono (10 dígitos)"
              :requerido="true"
            ></etiqueta-campo>
            <input
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              placeholder="Teléfono (10 dígitos)"
              class="form-control number campo-basico"
              v-model="prospecto.Telefono"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Debes ingresar teléfono del prospecto
            </div>
          </div>
          <div class="col-lg-6 col-sm-12 columna--campos">
            <etiqueta-campo
              texto="Correo electrónico"
              :requerido="true"
            ></etiqueta-campo>
            <input
              type="email"
              placeholder="Correo electrónico *"
              class="form-control campo-minuscula campo-basico"
              v-model="prospecto.Correo"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Debes ingresar correo electrónico del prospecto
            </div>
          </div>
        </div>
        <div v-if="!esRegistroDeFiguraAdicional">
          <div class="row row-cols-lg-12 w-100 fila--campos">
            <div class="col-lg-6 col-sm-12 columna--campos">
              <etiqueta-campo
                texto="Valor de la propiedad"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                v-model="prospecto.montoDeseado"
                class="form-control campo-basico"
                :options="{
                  digitGroupSeparator: ',',
                  decimalCharacter: '.',
                  decimalCharacterAlternative: '.',
                  currencySymbol: '$',
                  currencySymbolPlacement: 'p',
                  roundingMethod: 'U',
                  minimumValue: '0',
                  maximumValue: '15000000',
                }"
                :placeholder="'Ej. $ 2,500,000.00'"
                required
              ></VueAutonumeric>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes ingresar el valor de la propiedad que desea adquirir el
                prospecto
              </div>
            </div>
            <div class="col-lg-6 col-sm-12 columna--campos">
              <etiqueta-campo
                texto="¿Que tipo de inmueble desea adquirir el prospecto?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Selecciona el tipo de inmueble * "
                :arreglo="tiposInmueble"
                llave="value"
                valor="value"
                texto="text"
                :requerido="true"
                v-model="prospecto.TipoInmueble"
                invalidFeedback="Debes seleccionar el tipo de inmueble"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12 w-100 fila--campos">
            <div class="col-lg-6 col-sm-12 columna--campos">
              <etiqueta-campo
                texto="¿Que uso se le dará al inmueble?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Selecciona el uso del inmueble * "
                :arreglo="usosInmueble"
                llave="value"
                valor="value"
                texto="text"
                :requerido="true"
                v-model="prospecto.UsoInmueble"
                invalidFeedback="Debes seleccionar el uso del inmueble"
              ></DropDown>
            </div>
            <div class="col-lg-6 col-sm-12 columna--campos">
              <etiqueta-campo
                texto="¿Cuál es el tipo de ubicación del inmueble?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Selecciona el tipo de ubicación * "
                :arreglo="tiposUbicacionInmueble"
                llave="value"
                valor="value"
                texto="text"
                :requerido="true"
                v-model="prospecto.TipoUbicacion"
                invalidFeedback="Debes seleccionar el tipo de ubicación"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12 w-100 fila--campos">
            <div class="col-12 columna--campos">
              <etiqueta-campo
                texto="¿En que estado se ubica el inmueble?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Selecciona el estado donde se ubica el inmueble * "
                :arreglo="Estados"
                llave="estadoId"
                valor="estadoId"
                texto="descripcion"
                :requerido="true"
                v-model="prospecto.EstadoId"
                invalidFeedback="Debes seleccionar el estado donde se ubica el inmueble"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12 w-100 fila--campos">
            <div
              class="col-lg-6 col-sm-12 columna--campos"
              v-if="
                this.Proyectos.length > 0 &&
                  this.tipoUsuario != 6 &&
                  this.tipoUsuario != 8 &&
                  this.tipoUsuario != 9 &&
                  this.tipoUsuario != 10
              "
            >
              <etiqueta-campo texto="Proyecto:"></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Sucursales* "
                :arreglo="this.Proyectos"
                llave="proyectoVentaId"
                valor="proyectoVentaId"
                texto="nombre"
                v-model="Proyecto.proyectoVentaId"
                :requerido="true"
                invalidFeedback="Debes seleccionar una Sucursal"
              ></DropDown>
            </div>
            <div
              class="col-lg-6 col-sm-12 columna--campos"
              v-else-if="
                this.Proyectos.length > 0 &&
                  (this.tipoUsuario == 6 ||
                    this.tipoUsuario == 8 ||
                    this.tipoUsuario == 9 ||
                    this.tipoUsuario == 10)
              "
            >
              <etiqueta-campo texto="Proyecto:"></etiqueta-campo>
              <DropDown
                placeholder="Sucursales* "
                :arreglo="this.Proyectos"
                llave="proyectoVentaId"
                valor="proyectoVentaId"
                texto="nombre"
                v-model="Proyecto.proyectoVentaId"
                :requerido="true"
                invalidFeedback="Debes seleccionar una Sucursal"
              ></DropDown>
            </div>
            <div class="col-lg-6 col-sm-12 columna--campos" v-else>
              <etiqueta-campo texto="Proyecto:"></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                value="Este embajador no tiene proyecto asignado."
              />
            </div>
            <div
              class="col-lg-6 col-sm-12 columna--campos"
              v-if="
                this.Gerencias.length > 0 &&
                  this.tipoUsuario != 6 &&
                  this.tipoUsuario != 8 &&
                  this.tipoUsuario != 9 &&
                  this.tipoUsuario != 10
              "
            >
              <etiqueta-campo
                texto="Gerencia:"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Selecciona una gerencia * "
                :arreglo="this.Gerencias"
                llave="gerenciaId"
                valor="gerenciaId"
                texto="nombre"
                v-model="prospecto.GeneradorId"
                :requerido="true"
                invalidFeedback="Debes seleccionar una gerencia"
              ></DropDown>
            </div>
            <div
              class="col-lg-6 col-sm-12 columna--campos"
              v-else-if="
                this.Gerencias.length > 0 &&
                  (this.tipoUsuario == 6 ||
                    this.tipoUsuario == 8 ||
                    this.tipoUsuario == 9 ||
                    this.tipoUsuario == 10)
              "
            >
              <etiqueta-campo
                texto="Gerencia:"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Selecciona una gerencia * "
                :arreglo="this.Gerencias"
                llave="gerenciaId"
                valor="gerenciaId"
                texto="nombre"
                v-model="prospecto.GeneradorId"
                :requerido="true"
                invalidFeedback="Debes seleccionar una gerencia"
              ></DropDown>
            </div>
            <div class="col-lg-6 col-sm-12 columna--campos" v-else>
              <etiqueta-campo
                texto="Gerencia:"
                :requerido="true"
              ></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                value="Este proyecto no tiene gerencias"
              />
            </div>
            <div
              class="col-lg-6 col-sm-12 columna--campos"
              v-if="
                this.Embajadores.length > 0 &&
                  this.tipoUsuario != 6 &&
                  this.tipoUsuario != 8 &&
                  this.tipoUsuario != 9 &&
                  this.tipoUsuario != 10
              "
            >
              <etiqueta-campo
                texto="Embajador:"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Embajadores* "
                :arreglo="this.Embajadores"
                llave="embajadorId"
                valor="embajadorId"
                texto="nombre"
                v-model="prospecto.MasterId"
                :requerido="true"
                invalidFeedback="Debes seleccionar un embajador"
              ></DropDown>
            </div>
            <div
              class="col-lg-6 col-sm-12 columna--campos"
              v-else-if="
                this.Embajadores.length > 0 &&
                  (this.tipoUsuario == 6 ||
                    this.tipoUsuario == 8 ||
                    this.tipoUsuario == 9 ||
                    this.tipoUsuario == 10)
              "
            >
              <etiqueta-campo
                texto="Embajador:"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Embajadores* "
                :arreglo="this.Embajadores"
                llave="embajadorId"
                valor="embajadorId"
                texto="nombre"
                v-model="prospecto.MasterId"
                :requerido="true"
                invalidFeedback="Debes seleccionar un embajador"
              ></DropDown>
            </div>
            <div class="col-lg-6 col-sm-12 columna--campos" v-else>
              <etiqueta-campo
                texto="Embajador:"
                :requerido="true"
              ></etiqueta-campo>
              <input
                disabled
                type="text"
                class="form-control campo-basico"
                :value="this.LeyendaEmbajador"
              />
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12 w-100 fila--campos">
          <button
            ref="submitFormulario"
            @click.prevent="ValidaFormulario()"
            class="btn btn-primary"
            hidden
            type="submit"
          >
            Submit form
          </button>
          <label
            class="container-checkbox"
            v-if="mostrarCheckIntegracion && !esRegistroDeFiguraAdicional"
          >
            <input
              type="checkbox"
              checked="checked"
              v-model="prospecto.EnvioDirectoIntegracion"
            />
            <span class="checkmark"></span>
            Enviar directamente a integración de expediente
          </label>
          <div class="col-12">
            <button
              disabled
              class="btn boton-primario boton-registra-prospecto w-100"
              v-if="registrandoProspecto"
            >
              <v-progress-circular
                indeterminate
                size="30"
                color="primary"
              ></v-progress-circular>
            </button>
            <button
              v-else
              @click.prevent="ValidarFormularioRegistroProspecto()"
              class="btn boton-primario boton-registra-prospecto w-100"
            >
              {{
                this.prospecto.ProspectoId == 0
                  ? "Registrar"
                  : "Guardar cambios"
              }}
            </button>
          </div>
          <div class="col-12">
            <button
              @click.prevent="CancelarRegistroEdicion()"
              class="btn boton-primario boton-registra-prospecto w-100"
            >
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script lang="js">
//Componentes
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import DropDown from "../components/DropDown.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue"
//Importar plugins
import axios from "axios";
import servicios from '../../../servicios/service.js';

//Rutas de la API
const rutaCrearProspecto = "/api/Master/Prospecto/CrearProspecto";
const rutaCrearFiguraAdicional = "/api/Master/Prospecto/CrearProspectoFiguraAdicional";
const rutaEditarProspecto = "/api/Master/Prospecto/EditarProspecto";
//const rutaCargarEmbajadores = "/api/Master/Prospecto/ObtenerEmbajadores";
const rutaCargarProyecto = "/api/Master/Master/ListarProyectosPorJerarquia";
const rutaCargarGerencias = "/api/Master/Master/ListarGerenciasPorJerarquia";
const rutaCargarDatosProspecto = "/api/Master/Prospecto/ObtenerProspecto";
const rutaCargarTiposPersona = "/api/Master/Prospecto/ListarTipoPersona";
const rutaEnumTipoInmueble =
  "/api/Master/Prospecto/ObtenerEnumTipoInmueble";
const rutaEnumUsoInmueble =
  "/api/Master/Prospecto/ObtenerEnumUsoInmueble";
const rutaEnumTipoUbicacionInmueble =
  "/api/Master/Prospecto/ObtenerEnumTipoUbicacionInmueble";
const rutaEstadosInmueble =
  "/api/Master/Prospecto/ObtenerEstadosInmueble";

export default {
  name: "RegistroProspecto",
  components: {
    DropDown,
    TituloSeccion,
    VueAutonumeric
  },
  data() {
    return {
      LeyendaEmbajador: "Este proyecto y gerencia no tienen embajadores disponibles",
      esRegistro:false,
      esEdicion:false,
      Proyecto:{
        nombre:null,
        proyectoVentaId:null,
      },
      masters:{
        embajadorId: null,
      },
      Proyectos: [],
      prospectoPadreFiguraAdicionalId:null,
      prospecto: {
        ProspectoId: 0,
        Nombres: null,
        ApellidoPaterno: null,
        ApellidoMaterno: null,
        Telefono: null,
        Correo: null,
        montoDeseado: null,
        GeneradorId: null,
        TipoPersona: null,
        TipoInmueble: null,
        UsoInmueble: null,
        TipoUbicacion: null,
        EstadoId: null,
        EnvioDirectoIntegracion: false,
        MasterId: null,
      },
      Embajadores:[],
      Sucursales:[],
      Gerencias:[],
      TiposPersona:[],
      tipoUsuario: null,
      tiposInmueble: [],
      usosInmueble: [],
      tiposUbicacionInmueble: [],
      Estados: [],
      formularioRegistroProspectoValidado: false,
      registrandoProspecto: false,
      mostrarCheckIntegracion: true,
      esRegistroDeFiguraAdicional: false,
      tipoFiguraAdicional: null,
      titulo: "",
      EsGerente: false,
    };
  },
  async mounted (){
    this.esRegistroDeFiguraAdicional = this.$store.getters.registroFiguraAdicional;
    this.tipoFiguraAdicional = this.$store.getters.tipoFiguraAdicional;
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.esRegistro = this.$store.getters.crearProspecto;
    this.esEdicion = this.$store.getters.editarProspecto;

    if(this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10)
    {
      this.EsGerente = true;
    }

    if(this.esRegistro)
    {
      if(this.esRegistroDeFiguraAdicional)
      {
      this.titulo = "REGISTRA UN OBLIGADO SOLIDARIO O COTITULAR";
      }
      else{
      this.titulo = "REGISTRA UN PROSPECTO";
      }
    }
    else{
      if(this.esRegistroDeFiguraAdicional)
      {
      this.titulo = "EDITAR OBLIGADO SOLIDARIO O COTITULAR";
      }
      else{
      this.titulo = "EDITAR PROSPECTO";
      }
    }

    await this.CargarTiposPersona();

    if(!this.esRegistroDeFiguraAdicional) {
      await this.CargarProyecto();
      await this.CargarTiposInmueble();
      await this.CargarUsosInmueble();
      await this.CargarTiposUbicacionInmueble();
      await this.CargarEstadosInmueble();
    } else {
      this.prospectoPadreFiguraAdicionalId = this.$store.getters.prospectoPadreFiguraAdicionalId;
    }

    if(window.sessionStorage.getItem('prospectoEditarId')){
      this.ProspectoId = window.sessionStorage.getItem('prospectoEditarId');
      this.mostrarCheckIntegracion = false;
      await this.CargarDatosProspecto(this.ProspectoId);
      if(this.tipoUsuario != 6 && this.tipoUsuario != 8 && this.tipoUsuario != 9 && this.tipoUsuario != 10)
      {
        await this.CargarGerencias(this.ProyectoId);
      }
      else
      {
        await this.CargarProyecto();
      }
    }
  },
  watch: {
    "prospecto.Telefono" : function() {
      this.prospecto.Telefono = servicios.LimitarTelefonoLocal(this.prospecto.Telefono);
    },
    "Proyecto.proyectoVentaId" : function() {
      this.Gerencias = [];
      this.Embajadores = [];
      this.prospecto.GeneradorId = null;
      this.masters.embajadorId = null;
      this.CargarGerencias(this.Proyecto.proyectoVentaId);
    },
     "prospecto.GeneradorId" : function() {
      this.Embajadores = [],
      this.masters.embajadorId = null;
      this.CargarEmbajadores( this.Proyecto.proyectoVentaId, this.prospecto.GeneradorId);
    },
  },
  methods: {
    async CargarEmbajadores(proyectoId,gerenciaId) {
      const params = {
        params: { proyectoId: proyectoId, gerenciaId : gerenciaId },
      };
      await axios
        .get( "/api/Master/Master/ListarMasters",
          params)
        .then(response => {
          if (response.data.estado === 0) {
             this.Embajadores = response.data.data;
          if(this.tipoUsuario != 6 && this.tipoUsuario != 8 && this.tipoUsuario != 9 && this.tipoUsuario != 10)
          {
            this.prospecto.MasterId = this.Embajadores[0].embajadorId;
          }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarSucursales(conEmbajadores) {
      const params = {
        params: { conEmbajadores },
      };
      await axios
        .get( "/api/Master/Master/ListarProyectos",
          params)
        .then(response => {
          if (response.data.estado === 0) {
            this.Sucursales = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CancelarRegistroEdicion() {
      this.$store.commit('setCrearProspecto', false);
      this.$store.commit('setEditarProspecto', false);
      this.$store.commit('setRegistroFiguraAdicional',false);
      this.$router.push({
        name: "AdministracionDeProspectos"
      });
    },
    async CargarTiposInmueble() {
      await axios
        .get(rutaEnumTipoInmueble)
        .then(response => {
          if (response.data.estado === 0) {
            this.tiposInmueble = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarUsosInmueble() {
      await axios
        .get(rutaEnumUsoInmueble)
        .then(response => {
          if (response.data.estado === 0) {
            this.usosInmueble = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposUbicacionInmueble() {
      await axios
        .get(rutaEnumTipoUbicacionInmueble)
        .then(response => {
          if (response.data.estado === 0) {
            this.tiposUbicacionInmueble = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
   async CargarEstadosInmueble() {
     await axios
        .get(rutaEstadosInmueble)
        .then(res => {
          if (res.data.estado === 0) {
            this.Estados = res.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ValidarFormularioRegistroProspecto(){
      this.$refs.submitFormulario.click();
    },
    ValidaFormulario(){
      let formularioValidado = false;
      this.formularioRegistroProspectoValidado = true;
      formularioValidado = this.$refs.formularioRegistroProspecto.checkValidity();
      if(formularioValidado){
        this.ValidaDatosProspecto();
      }
    },
    ValidaDatosProspecto() {
       if(this.prospecto.Telefono.length != 10){
         this.AlertaEmbajadores("El teléfono debe de contar con 10 dígitos.",true);
          return;
       }

       if(this.prospecto.TipoPersona == '1') {
         var expresionRegular = /[a-zA-Z]{3,3}[0-9]{2}[0-1][0-9][0-3][0-9][a-zA-Z,0-9][a-zA-Z,0-9][0-9aA]$/;
         if ((!expresionRegular.test(this.prospecto.ApellidoMaterno.toUpperCase()) || this.prospecto.ApellidoMaterno.length != 12) && this.prospecto.ApellidoMaterno.length != 0)
         {
            this.AlertaEmbajadores("El rfc " + this.prospecto.ApellidoMaterno.toUpperCase() + " no cuenta con la longitud de 12 o el formato establecido 3 Letras, 6 números y 3 dígitos aleatorios(homoclave)." ,true);
            return;
         }
       }

        if(window.sessionStorage.getItem('prospectoEditarId')){
          this.NormalizarTiposDatos();
          this.EditarProspecto(this.prospecto);
        }
        else if(!this.esRegistroDeFiguraAdicional){
          this.NormalizarTiposDatos();
          this.RegistrarProspecto(this.prospecto);
        } else {
          var figuraAdicional = {
            tipoFigura : this.prospecto.TipoPersona,
            prospectoPadreId : this.prospectoPadreFiguraAdicionalId,
            nombres : this.prospecto.Nombres,
            apellidoPaterno : this.prospecto.ApellidoPaterno,
            apellidoMaterno : this.prospecto.ApellidoMaterno,
            telefono : this.prospecto.Telefono,
            correoElectronico : this.prospecto.Correo
          }
          this.RegistrarFiguraAdicional(figuraAdicional);
        }

    },
    NormalizarTiposDatos(){
      this.prospecto.EstadoId = parseInt(this.prospecto.EstadoId);
      this.prospecto.TipoInmueble = parseInt(this.prospecto.TipoInmueble);
      this.prospecto.UsoInmueble = parseInt(this.prospecto.UsoInmueble);
      this.prospecto.TipoUbicacion = parseInt(this.prospecto.TipoUbicacion);
      this.prospecto.TipoPersona = parseInt(this.prospecto.TipoPersona);
    },
    //Validaciones
    EsExpresionValidaNombre(nombreProspecto) {
        let regExp = new RegExp("^[A-Za-zÀ-ÿ/ ]+?$");
        return regExp.test(nombreProspecto)
    },
    RegistrarProspecto: function(prospecto) {
      this.registrandoProspecto = true;

      const {MasterId} = prospecto;
      if(MasterId === null)
      {
        this.AlertaEmbajadores("Debes seleccionar un embajador", true);
        this.registrandoProspecto = false;
        return;
      }

      axios.post(rutaCrearProspecto, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.registrandoProspecto = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
            this.$router.push({
              name: "AdministracionDeProspectos"
            });
          } else if (resp.data.estado === 1) {
            this.registrandoProspecto = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.registrandoProspecto = false;
          this.ManejarExcepcion(e);
        });
    },
    EditarProspecto: function(prospecto) {
      axios.post(rutaEditarProspecto, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
            this.$router.push({name: "AdministracionDeProspectos"});
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
           this.ManejarExcepcion(e);
        });
    },
    async CargarDatosProspecto(prospectoId){
      if(prospectoId != null){
        const parametroProspectoId = {
          params:{
            ProspectoId:prospectoId
          }
        }
        await axios.get(rutaCargarDatosProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.prospecto.ProspectoId = resp.data.data.prospectoId;
            this.prospecto.Nombres = resp.data.data.nombres;
            this.prospecto.ApellidoPaterno = resp.data.data.apellidoPaterno;
            this.prospecto.ApellidoMaterno = resp.data.data.apellidoMaterno;
            this.prospecto.GeneradorId = resp.data.data.generadorId;
            this.prospecto.Telefono = resp.data.data.telefono;
            this.prospecto.Correo = resp.data.data.correo;
            this.Proyecto.ProyectoVentaId = resp.data.data.proyectoId;
            this.prospecto.TipoPersona = resp.data.data.tipoPersona;
            this.prospecto.montoDeseado = resp.data.data.montoDeseado;
            this.prospecto.TipoInmueble = resp.data.data.tipoInmueble;
            this.prospecto.UsoInmueble = resp.data.data.usoInmueble;
            this.prospecto.TipoUbicacion = resp.data.data.tipoUbicacion;
            this.prospecto.EstadoId = resp.data.data.estadoId;
          }
        }).catch((e) => {
          this.ManejarExcepcion(e);
        });
      }
    },
    async CargarProyecto(){
      await axios.get(rutaCargarProyecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          if(resp.data.data != null) {
            this.Proyectos = resp.data.data;
             if(this.tipoUsuario != 6 && this.tipoUsuario != 8 && this.tipoUsuario != 9 && this.tipoUsuario != 10)
      {
            this.Proyecto.proyectoVentaId = this.Proyectos[0].proyectoVentaId;
            this.CargarGerencias( this.Proyecto.proyectoVentaId);
      }
          }
        } else if (resp.data.estado === 1) {
          this.AlertaEmbajadores(resp.data.mensjae, false);
        }
      }).catch((e) => {
         this.ManejarExcepcion(e);
      });
    },
    async CargarGerencias(ProyectoId){
      const parametroProyectoId = {
        params:{
          ProyectoId: ProyectoId
        }
      }
      await axios
      .get(rutaCargarGerencias,parametroProyectoId)
      .then((resp) => {
        if (resp.data.estado === 0) {
            this.Gerencias = resp.data.data;
            if(this.tipoUsuario != 6 && this.tipoUsuario != 8 && this.tipoUsuario != 9 && this.tipoUsuario != 10)
            {
              this.prospecto.GeneradorId = this.Gerencias[0].gerenciaId;
              this.CargarEmbajadores(this.Proyecto.proyectoVentaId, this.prospecto.GeneradorId);
            }
          if(window.sessionStorage.getItem('prospectoEditarId'))
            this.GeneradorId = this.prospecto.GeneradorId
        }
      })
      .catch((e) => {
         this.ManejarExcepcion(e);
      });
    },
    async CargarTiposPersona(){
      await axios.get(rutaCargarTiposPersona)
      .then((resp) => {
        if (resp.data.estado === 0)
        {

      if(this.esRegistro)
        {
        this.TiposPersona = resp.data.data;
      if(this.esRegistroDeFiguraAdicional)
            {
              if(this.tipoFiguraAdicional == 4 || this.tipoFiguraAdicional == 5)
                {
                  this.TiposPersona = this.TiposPersona.filter(tipo => {
                  if(tipo.value == 4 || tipo.value == 5)
                  return true;
                  return false;
                  });
                }
                else if(this.tipoFiguraAdicional == 6 || this.tipoFiguraAdicional == 7)
                {
                  this.TiposPersona = this.TiposPersona.filter(tipo => {
                  if(tipo.value == 6 || tipo.value == 7) return true;
                  return false;
                  });
                }
              } else {
                  this.TiposPersona = this.TiposPersona.filter(tipo => {
                  if(tipo.value == 0 || tipo.value == 1 || tipo.value == 2) return true;
                  return false;
                  });
              }
            }
            else{
              this.TiposPersona = resp.data.data;
            }
          }
        }).catch((e) => {
          this.ManejarExcepcion(e);
        })
    },
    async RegistrarFiguraAdicional(figuraAdicional){
      await axios.post(rutaCrearFiguraAdicional, figuraAdicional)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
            this.$router.push({name: "AdministracionDeProspectos"});
            caches.delete();
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
           this.ManejarExcepcion(e);
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.formularioprospecto-princ {
  background-color: #ffffff;
  flex-grow: 1;
}

.container-registro-prospecto .row {
  margin-left: 0px;
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
  appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.container-checkbox {
  text-align: left;
  display: block;
  position: relative;
  padding-left: 40px;
  margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.container-checkbox .checkmark {
  position: absolute;
  left: 10px;
  top: 2px;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 2px solid #b8725a;
}

.container-checkbox:hover input ~ .checkmark {
  background-color: #bea197;
}

.container-checkbox input:checked ~ .checkmark {
  background-color: #b8725a;
}

.container-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.container-checkbox .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
